import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/** A raffle task's earned-ticket count on a ticket stub (`.ticket-badge`, index.css): the prize
 *  colour while the task can still earn, a quiet grey once it has paid all it can. */
export const TicketBadge = ({
  count,
  muted = false,
  className,
}: {
  count: number;
  muted?: boolean;
  className?: string;
}) => (
  <span
    aria-hidden
    className={cn(
      "ticket-badge flex h-9 min-w-11 shrink-0 items-center justify-center rounded-lg px-3 font-heading text-[18px] leading-none font-extrabold tabular-nums",
      muted
        ? "bg-background-card-surface text-muted-foreground"
        : "bg-prizes text-background",
      className
    )}
  >
    {count}
  </span>
);

/** The "+1 ticket" pill at the far end of an open task row: the same notched stub as
 *  `TicketBadge`, at text size. */
export const TicketPill = ({ children }: { children: ReactNode }) => (
  <span className="ticket-badge flex h-7 shrink-0 items-center rounded-md bg-prizes px-3 font-heading text-[13px] leading-none font-bold whitespace-nowrap text-background lg:text-[14px]">
    {children}
  </span>
);
